import { actionTypes } from "../../actions/action_types";

var current = new Date();
let default_pma_month = current.getMonth() + 1;
let default_pma_year = current.getFullYear();

const initialState = {
  pma_month: default_pma_month,
  pma_year: default_pma_year,
  areaSummaries: [],
  clusterSummaries: [],
  branchSummaries: [],
};

export default function previous_month_average_reducer(
  state = initialState,
  action
) {
  var stateCopy = Object.assign({}, state);

  switch (action.type) {
    case actionTypes.REPORTS_PREVIOUSMONTH_AVERAGE_SET_SCOPE_DATE:
      stateCopy.pma_month = action.payload.month;
      stateCopy.pma_year = action.payload.year;
      return stateCopy;

    case actionTypes.REPORTS_PREVIOUSMONTH_AVERAGE_GET_CLUSTER:
      stateCopy.clusterSummaries = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_PREVIOUSMONTH_AVERAGE_GET_AREA:
      stateCopy.areaSummaries = action.payload;
      return stateCopy;

    case actionTypes.REPORTS_PREVIOUSMONTH_AVERAGE_GET_BRANCH:
      stateCopy.branchSummaries = action.payload;
      return stateCopy;

    default:
      return state;
  }
}
